<template>
  <div>
    <public />
    <billing-information />
  </div>
</template>

<script>
import Public from '@/views/Customers/CustomerForm/Public.vue'
import BillingInformation from '@/views/Customers/CustomerForm/BillingInformation.vue'

export default {
  name: 'CustomerForm',
  components: {
    Public,
    BillingInformation,
  },
}
</script>
